import { Link } from "react-router-dom";
import { Phone, MapPin, Facebook, Music2, Instagram } from "lucide-react";
import { CONTACTS } from "../data/site";
import { useLang } from "../i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-neon/15 bg-pine" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4 mb-5">
            <img src="/assets/bella-script.png" alt="Bella" className="h-12 w-auto" />
          </div>
          <p className="text-fog leading-relaxed max-w-sm">{t("footer.tagline")}</p>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-head font-bold uppercase tracking-[0.2em] text-sm text-neon mb-5">{t("footer.contacts")}</h4>
          <ul className="space-y-3 text-fog">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-neon shrink-0 mt-0.5" />
              <span>{CONTACTS.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-neon shrink-0" />
              <a href={CONTACTS.phoneHref} className="hover:text-neon transition-colors duration-300">{CONTACTS.phone}</a>
            </li>
            <li className="flex items-center gap-4 pt-2">
              <a href={CONTACTS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook"
                 className="w-10 h-10 border border-neon/25 flex items-center justify-center text-fog hover:text-ink hover:bg-neon transition-colors duration-300">
                <Facebook size={18} />
              </a>
              <a href={CONTACTS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram"
                 className="w-10 h-10 border border-neon/25 flex items-center justify-center text-fog hover:text-ink hover:bg-neon transition-colors duration-300">
                <Instagram size={18} />
              </a>
              <a href={CONTACTS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="footer-tiktok"
                 className="w-10 h-10 border border-neon/25 flex items-center justify-center text-fog hover:text-ink hover:bg-neon transition-colors duration-300">
                <Music2 size={18} />
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-head font-bold uppercase tracking-[0.2em] text-sm text-neon mb-5">{t("footer.hours")}</h4>
          <ul className="space-y-2 text-fog text-sm">
            <li className="flex justify-between gap-4"><span>{t("footer.days")}</span><span className="text-foreground">19:00 — 00:00</span></li>
            <li className="flex justify-between gap-4"><span>{t("footer.monday")}</span><span className="text-neon">{t("footer.closed")}</span></li>
          </ul>
          <Link to="/prenota" data-testid="footer-cta-prenota"
            className="inline-block mt-6 border border-neon text-neon font-head font-bold text-xs tracking-[0.2em] uppercase px-6 py-3 rounded-full hover:bg-neon hover:text-ink transition-colors duration-300">
            {t("footer.bookCta")}
          </Link>
        </div>
      </div>
      <div className="border-t border-neon/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-fog/70">
          <span>© {new Date().getFullYear()} Pizzeria Bella — Acireale</span>
          <Link to="/admin" className="hover:text-neon transition-colors duration-300" data-testid="footer-admin-link">{t("footer.admin")}</Link>
        </div>
      </div>
    </footer>
  );
};
